export enum QaroniMatDialogDirectionEnum {
  LTR = 'LTR',
  RTL = 'RTL',
}

export type QaroniMatDialogDirectionType =
  | QaroniMatDialogDirectionEnum.RTL
  | QaroniMatDialogDirectionEnum.LTR;
